import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

interface Props extends TooltipProps {
  color?: string // Color Hex value
}

const WordTooltip = ({ color, ...props }: Props): React.ReactElement => {
  const tooltipProps = {
    tooltip: {
      sx: {
        backgroundColor: color || '#7d38d7',
        color: '#fff',
        fontSize: '14px',
        letterSpacing: '0.75px',
        lineHeight: '24px',
        minWidth: '250px',
        maxWidth: '250px',
        padding: '6px',
        borderRadius: '16px',
        fontWeight: 'normal',
        boxShadow: '#00000042 1px -1px 5px',
        left: 25,
        [`& .${tooltipClasses.arrow}`]: {
          color: color || '#7d38d7',
          width: '24px',
          height: '17px',
        },
        [`&.${tooltipClasses.tooltipPlacementTop}`]: {
          [`& .${tooltipClasses.arrow}`]: {
            marginBottom: '-16px',
          },
        },
        [`&.${tooltipClasses.tooltipPlacementBottom}`]: {
          [`& .${tooltipClasses.arrow}`]: {
            marginTop: '-16px',
          },
        },
      },
    },
  }

  return <Tooltip componentsProps={tooltipProps} {...props} />
}

export default WordTooltip
